import React, { useState } from "react";
import ArchiveMission from "./ArchiveMission/ArchiveMission";
import "./ArchiveMissionsDisplay.css";

const ArchiveMissionsDisplay = ({ archiveMissions }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const missionsPerPage = 20;

  // Calcul des indices pour la pagination
  const indexOfLastMission = currentPage * missionsPerPage;
  const indexOfFirstMission = indexOfLastMission - missionsPerPage;
  const currentMissions = archiveMissions.slice(indexOfFirstMission, indexOfLastMission);
  const totalPages = Math.max(1, Math.ceil(archiveMissions.length / missionsPerPage));

  const handleNextPage = () => {
    if (currentPage < totalPages && archiveMissions.length > 0) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1 && archiveMissions.length > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="archive-missions-display">
      <h2>Résultats de la recherche</h2>
      {archiveMissions.length === 0 ? (
        <div className="no-results">
          <p>Aucune mission trouvée. Veuillez ajuster vos critères de recherche.</p>
        </div>
      ) : (
        <>
          <div className="missions-grid">
            {currentMissions.map((mission, index) => (
              <ArchiveMission key={mission.id || index} mission={mission} />
            ))}
          </div>
          <div className="pagination-controls">
            <button 
              onClick={handlePrevPage} 
              disabled={currentPage === 1 || archiveMissions.length === 0}
              className="pagination-button"
            >
              ←
            </button>
            <span className="page-indicator">
              Page {archiveMissions.length === 0 ? 0 : currentPage} sur {archiveMissions.length === 0 ? 0 : totalPages}
            </span>
            <button 
              onClick={handleNextPage} 
              disabled={currentPage === totalPages || archiveMissions.length === 0}
              className="pagination-button"
            >
              →
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ArchiveMissionsDisplay;
